

/**
 * 游戏配置接口
 */

import { IsNeedChildChildGameId, notNeedChildGameId } from '@/constant';
import request from '@/utils/request';
import { dealPageParms } from '@/utils/utils';
import type { PaginatedParams } from 'ahooks/lib/useAntdTable';

/*
*获子游戏列表
*/
export function getChildGameList(
  pageInfo: PaginatedParams[0],
    props: any,
    ): Promise<any> {
    // const targetParams = { ...props, pageNum: current, pageSize };
    return request('/mng/childGame/page', {
    method: 'POST',
    data:  dealPageParms(pageInfo,props),
    });
}
/**
 * 新增子游戏接口
 * @param body 
 */
export function childGameAdd(body: any): Promise<any> {
   return request('/mng/childGame/add',{
     method:'POST',
     data:body,
     headers:{
      [IsNeedChildChildGameId]:notNeedChildGameId
     }

  });
}

/**
 * 修改子游戏接口
 * @param body 
 */
export function childGameUpdate(body: any): Promise<any> {
  return request('/mng/childGame/edit',{
    method:'POST',
    data:body,
 });
}

/**
 * 删除子游戏接口
 * @param body 
 */
export function childGameDelete(id: string,type: number): Promise<any> {
  return request('/mng/childGame/delete',{
    method:'POST',
    data:{id,type}
 });
}

/**
 * 获取单个信息
 * @param param 对象{id}
 * @param id  配置id
 */

export function getchildGameInfo(id: string): Promise<any> {
    return request('/mng/childGame/get', {
        method: 'POST',
        data:{id}
    });
  }
/**
 * 获取子游戏下拉列表
 * @param param 对象{id}
 * @param id  配置id
 */

export function getChildDropDownList(gameId: string): Promise<any> {
  return request('/mng/childGame/dropDownList', {
      method: 'POST',
      data:{
        gameId
      }
  });
}